import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { history } from '../../../helpers/history';
import SupplierFilters from './SupplierFilters';
import parseQuerystring from '../../../helpers/parseQuerystring';
import classnames from 'classnames';

import _isEmpty from 'lodash/isEmpty';

import Table from '../../shared/Table/Table';
import { columns, mapData } from './TableMetadata';

import combineStyles from '../../../helpers/combineStyles';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import TypographyStyles from '../../../styles/typography';
import SpacingStyles from '../../../styles/helpers/spacing';
import ListsStyle from '../__styles__/Lists.style';

import { DEFAULT_ROWS_PER_PAGE } from '../../../constants/request_constants';

class PointOfSaleList extends React.Component {
  state = {
    rowsPerPage: sessionStorage.getItem('BrillaRowsPerPage')
      ? parseInt(sessionStorage.getItem('BrillaRowsPerPage'), 10)
      : DEFAULT_ROWS_PER_PAGE,
    isOpenedCreateUserModal: false,
  };

  componentDidMount() {
    this._fetchItems();
    if (this.props.corporations.length === 0) {
      this.props.fetchCorporationNames();
    }
  }

  _fetchItems = params => {
    const query = params || parseQuerystring(this.props) || {};
    this.props.fetchSuppliers({
      ...query,
      page: query.page || 1,
      rowsPerPage: this.state.rowsPerPage
    });
  };

  _handleRowClick = id => {
    history.push(`/suppliers/${id}`);
  };

  _handleChangePage = page => {
    const query = parseQuerystring(this.props) || {};
    this._fetchItems({
      ...query,
      page: page + 1
    });
  };

  _handleChangeRowsPerPage = rowsPerPage => {
    sessionStorage.setItem('BrillaRowsPerPage', rowsPerPage);
    this.setState({ rowsPerPage: rowsPerPage, page: 1 }, this._fetchItems);
  };

  render() {
    const {
      classes,
      suppliers = [],
      meta = {},
      requestSend = true
    } = this.props;
    const { page } = parseQuerystring(this.props) || {};

    return (
      <div>
        <div className={classes.titleRootWrapper}>
          <h1 className={classnames(classes.headline4, classes.title)}>
            {'Proveedores'}
          </h1>
        </div>
        <div>
          <div className={classes.filterOptionsWrapper}>
            <SupplierFilters
              onChangeFilter={this._fetchItems}
              corporations={this.props.corporations}
            />
          </div>
        </div>
        <div>
          <Table
            name={'Proveedor'}
            columns={columns}
            data={mapData(suppliers)}
            onChangePage={this._handleChangePage}
            onChangePageRowsPerPage={this._handleChangeRowsPerPage}
            page={Number(meta && meta.currentPage) - 1}
            rowsPerPage={this.state.rowsPerPage}
            onClickOnRow={props => this._handleRowClick(props.id)}
            loading={requestSend}
            withNoCountPagination
            nextPage={meta && meta.nextPage}
          />
        </div>
      </div>
    );
  }

}

const styles = (/* theme */) => ({
});

PointOfSaleList.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object
};

export default withStyles(combineStyles(
  LayoutStyles,
  ButtonStyles,
  TypographyStyles,
  SpacingStyles,
  ListsStyle,
  styles
),)(PointOfSaleList);
